import GitHubButton from 'react-github-btn';
import * as React from 'react';
export default {
  GitHubButton,
  React
};